import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { SignedInBar, VoteGoalPage } from '@/components/race-picture';
import { isVoteGoalOn } from '@/config/customerConfig';

export const Route = createFileRoute('/app/vote-goal')({
  validateSearch: z.object({ from: z.literal('win-number').optional() }),
  beforeLoad: () => {
    if (!isVoteGoalOn()) throw redirect({ to: '/app/home' });
  },
  component: VoteGoalRoute,
});

function VoteGoalRoute() {
  const { from } = Route.useSearch();
  return (
    <>
      {from === 'win-number' && <SignedInBar />}
      <VoteGoalPage />
    </>
  );
}
